import { IsUrl, IsFQDN, validateSync } from 'class-validator';

export function getParameterByName(name: string) {
    const match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export const formatUrl = (url?: string | string[]) => {
    if (url?.includes('http')) return url;
    return 'https://' + url;
};

export function getSearchParam(key: string) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
}

export function deleteSearchParam(key: string) {
    const params = new URLSearchParams(window.location.search);
    params.delete(key);
}

export const isDomainValid = (url: string): boolean => {
    if (!url) return false;

    const rawDomain = url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '');
    class Domain {
        @IsFQDN()
        url: string;

        constructor(url: string) {
            this.url = url;
        }
    }

    const domainModel = new Domain(rawDomain);
    const errors = validateSync(domainModel);
    if (errors.length > 0) {
        return false;
    }
    return true;
};

export const isUrlValid = (url: string): boolean => {
    if (!url) return false;

    class URL {
        @IsUrl()
        url: string;

        constructor(url: string) {
            this.url = url;
        }
    }

    const urlModel = new URL(url);
    const errors = validateSync(urlModel);
    if (errors.length > 0) {
        return false;
    }
    return true;
};
